module.exports = __webpack_public_path__ + "img/4.c8c78648.png";